import {
  GET_LOYALTY,
  CREATE_LOYALTY,
  ADD_SUBSCRIPTION,
  EDIT_LOYALTY,
  RESET_LOYALTY,
  DEACTIVATE_LOYALTY,
  REACTIVATE_LOYALTY
} from './constants'

export function getLoyalty (businessId) {
  return axios
    .get(GET_LOYALTY(businessId))
    .then((res) => {
      // return new Promise(resolve => setTimeout(() => resolve(res), 3000))
      return Promise.resolve(res)
    })
    .catch((error) => {
      let errorObj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          errorObj = new Error(data.errors)
        } else if (data.message) {
          errorObj = new Error(data.message)
        } else {
          errorObj = new Error(error.message)
        }
      } else {
        errorObj = new Error(error.message)
      }
      return Promise.reject(errorObj)
    })
}

export function createLoyalty (businessId, data) {
  return axios
    .post(CREATE_LOYALTY(businessId), data)
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let errorObj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          errorObj = new Error(data.errors)
        } else if (data.message) {
          errorObj = new Error(data.message)
        } else {
          errorObj = new Error(error.message)
        }
      } else {
        errorObj = new Error(error.message)
      }
      return Promise.reject(errorObj)
    })
}

export function editLoyalty (businessId, data) {
  return axios
    .put(EDIT_LOYALTY(businessId), data)
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let errorObj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          errorObj = new Error(data.errors)
        } else if (data.message) {
          errorObj = new Error(data.message)
        } else {
          errorObj = new Error(error.message)
        }
      } else {
        errorObj = new Error(error.message)
      }
      return Promise.reject(errorObj)
    })
}

export function resetLoyalty (businessId, data) {
  return axios
    .patch(RESET_LOYALTY(businessId), data)
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let errorObj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          errorObj = new Error(data.errors)
        } else if (data.message) {
          errorObj = new Error(data.message)
        } else {
          errorObj = new Error(error.message)
        }
      } else {
        errorObj = new Error(error.message)
      }
      return Promise.reject(errorObj)
    })
}

export function deactivateLoyalty (businessId) {
  return axios
    .patch(DEACTIVATE_LOYALTY(businessId))
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let errorObj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          errorObj = new Error(data.errors)
        } else if (data.message) {
          errorObj = new Error(data.message)
        } else {
          errorObj = new Error(error.message)
        }
      } else {
        errorObj = new Error(error.message)
      }
      return Promise.reject(errorObj)
    })
}

export function reactivateLoyalty (businessId, data) {
  let url = REACTIVATE_LOYALTY(businessId)
  if (data.reset) {
    url = `${url}?reset=${data.reset}`
  }
  return axios
    .patch(url).then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let errorObj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          errorObj = new Error(data.errors)
        } else if (data.message) {
          errorObj = new Error(data.message)
        } else {
          errorObj = new Error(error.message)
        }
      } else {
        errorObj = new Error(error.message)
      }
      return Promise.reject(errorObj)
    })
}

export function addSubscription () {
  return axios
    .put(ADD_SUBSCRIPTION, {
      feature_name: 'Loyalty'
    }, { withCredentials: true })
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let errorObj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          errorObj = new Error(data.errors)
        } else if (data.message) {
          errorObj = new Error(data.message)
        } else {
          errorObj = new Error(error.message)
        }
      } else {
        errorObj = new Error(error.message)
      }
      return Promise.reject(errorObj)
    })
}



// WEBPACK FOOTER //
// ./app/api/customers/loyalty/loyalty.js